// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list[data-v-21d7e14d] {\n  display: flex;\n  margin-top: 8px;\n}\n.list .item[data-v-21d7e14d] {\n    margin-right: 40px;\n}\n.title[data-v-21d7e14d] {\n  margin-top: 10px;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
